"use strict";

var fus = {};

(function() {

	/***************************************
		Common methods
	***************************************/

	var isTouchDevice = function() { return 'ontouchstart' in window || navigator.maxTouchPoints; }
	var vpWidth = function() { return Math.max(document.documentElement.clientWidth, window.innerWidth || 0); }
	var vpHeight = function() { return Math.max(document.documentElement.clientHeight, window.innerHeight || 0); }
	var getScrollingElement = function() { return document.scrollingElement ? document.scrollingElement : document.documentElement; }
	var getScrollPos = function() { return getScrollingElement().scrollTop || window.pageYOffset; }
	var isIE = function() { return document.body.classList.contains('is-ie'); };
	var isFirefox = function() { return document.body.classList.contains('is-firefox'); };
	var isSafari = function() { return navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') == -1; }

	function xhrCors(method, url, async) {
		var xhr = new XMLHttpRequest();
		async = async || false;

		if ("withCredentials" in xhr) {
			xhr.open(method, url, async);
		} else if (typeof XDomainRequest != "undefined") {
				xhr = new XDomainRequest();
			xhr.open(method, url);
		} else {
			xhr = null;
		}

		return xhr;
	}

	function debounce(func, delay) {
		var wait;

		delay = delay || 50;
		return (function() {
			var context = this,
				args = arguments;

			clearTimeout(wait);
			wait = setTimeout(function() {
				func.apply(context, args);
			}, delay);
		})();
	}

	/***************************************
		Main Events
	***************************************/

	var imgPreloader, vidPreloader, resizer;

	var init = function() {
		imgPreloader      = new ImagePreloader();
		vidPreloader      = new VideoPreloader();
		resizer           = resizeBody();

		resizeIframes();
		toggleMenu();
		horizontalHeaderMenu();
		autoSwitchMenu();
		sliders();
		expandableItems();
		contactForms();
		showLanguageSubMenu();
		videos();
		registerMap();
		toggleCollapsibles();
		credits();

		setTimeout(updateHeaderHeight, 200);
		window.addEventListener('resize', updateHeaderHeight);

		fus = {
			isTouchDevice, vpWidth, vpHeight, getScrollingElement, getScrollPos,
			isIE, isFirefox, isSafari, xhrCors, debounce, resizer, imgPreloader,
			vidPreloader, SwipeDetect, updateHeaderHeight
		};
	}



	var resizeBody = function() {
		var changeHeight = function() {
			var root = document.documentElement,
				height = window.innerHeight,
				width  = vpWidth(),
				vw = 0.01 * document.body.clientWidth,
				vh = 0.01 * window.innerHeight;

			root.style.setProperty('--vw', vw + 'px');
			root.style.setProperty('--vh', vh + 'px');
			document.body.style.height = window.innerHeight + 'px';
		}

		setTimeout(changeHeight, 20);
		window.addEventListener('resize', changeHeight);

		return changeHeight;
	}

	var updateHeaderHeight = function() {
		var root   = document.documentElement,
			header = document.querySelector('.header'),
			footer = document.querySelector('.footer');
		
		if (header)	
			root.style.setProperty('--headerHeight', header.getBoundingClientRect().height + 'px');

		if (footer)	
			root.style.setProperty('--footerHeight', footer.getBoundingClientRect().height + 'px');
	}




	/**************************************************
		Lazy Loading
	**************************************************/

	class ImagePreloader {
		constructor(wrapper) {
			this.wrapper = wrapper || document;
			this.images  = [].slice.call(this.wrapper.querySelectorAll('img.lazy'));

			if ('loading' in document.createElement('img'))
				return this.loadImagesNow();

			this.prepareImages();
			this.checkVisibility();
			this.registerEvents();
		}

		prepareImages() {
			this.images.forEach(function(image) {
				if (image.nextElementSibling && image.nextElementSibling.tagName === 'NOSCRIPT')
					image.parentElement.removeChild(image.nextElementSibling);

				var parentWidth   = image.parentElement.scrollWidth,
					naturalWidth  = image.getAttribute('width'),
					naturalHeight = image.getAttribute('height'),
					newHeight     = naturalHeight * parentWidth / naturalWidth;

				image.style.height = newHeight  + 'px';
			});
		}

		checkVisibility() {
			if (this.images.length == 0) return;

			debounce((function() {				
				var winWidth = vpWidth(),
					winHeight = vpHeight();

				this.images = this.images.filter((function(image) {
					var clientRect = image.getBoundingClientRect();

					if (clientRect.top + clientRect.height >= 0 &&
						clientRect.top < winHeight &&
						clientRect.left + clientRect.width >= 0 &&
						clientRect.left < winWidth) {

						this.loadImage(image);
						return false;
					}

					return true;
				}).bind(this));
			}).bind(this));
		};

		loadImage(image) {
			if (!image || !image.classList.contains('lazy')) return;

			image.src    = image.dataset.src;
			image.srcset = image.dataset.srcset;
			image.classList.add('loaded');
			image.style.height = '';

			setTimeout(function() {
				image.classList.remove('lazy', 'loaded');
				image.removeAttribute('data-src');
				image.removeAttribute('data-srcset');
			}, 1000);
		}

		loadImagesNow(wrapper) {
			wrapper = wrapper || document;

			var imgs = wrapper.querySelectorAll('img.lazy');
			[].forEach.call(imgs, (function(img) {
				this.loadImage(img);
			}).bind(this));
		}

		registerEvents() {
			window.addEventListener('scroll', (function() { this.checkVisibility(); }).bind(this), { passive: false });
			window.addEventListener('resize', (function() { this.checkVisibility(); }).bind(this), false);
		}
	}



	class VideoPreloader {
		constructor(wrapper) {
			this.wrapper = wrapper || document;
			this.videos  = [].slice.call(this.wrapper.querySelectorAll('video.lazy'));
			this.threshold = 20;

			this.prepareVideos();
			this.checkVisibility();
			this.registerEvents();
		}

		prepareVideos() {
			this.videos.forEach(function(video) {
				var parentWidth   = video.parentElement.scrollWidth,
					naturalWidth  = video.getAttribute('width'),
					naturalHeight = video.getAttribute('height'),
					newHeight     = naturalHeight * parentWidth / naturalWidth;

				video.style.height = newHeight  + 'px';
			});
		}

		checkVisibility() {
			if (this.videos.length == 0) return;

			debounce((function() {				
				var winWidth = vpWidth(),
					winHeight = vpHeight();

				this.videos = this.videos.filter((function(video) {
					var clientRect = video.getBoundingClientRect();

					if (clientRect.top + clientRect.height <= 0) return true;
					if (clientRect.top >= winHeight) return true;
					if (clientRect.left + clientRect.width <= 0) return true;
					if (clientRect.left >= winWidth) return true;

					let elem    = video,
						visible = true;

					while (elem && visible == true) {
						let opacity = getComputedStyle(elem).getPropertyValue('opacity');
						visible = visible && (opacity == '' || parseFloat(opacity) !== 0);
						visible = visible && elem.style.display !== 'none';
						visible = visible && elem.style.visibility !== 'hidden';

						elem = elem.parentElement || null;
					}

					if (visible == false) return;

					this.loadVideo(video);
					return false;
				}).bind(this));
			}).bind(this));
		};

		loadVideo(elem) {
			if (!elem || elem.loading === true || !elem.classList.contains('lazy')) return;

			elem.loading = true;
			elem.classList.add('is-loading');

			var files   = JSON.parse(elem.dataset.sources),
				width   = elem.parentElement.getBoundingClientRect().width,
				mimes   = {},
				sources = '';


			files.forEach(function(file) {
				if (!mimes.hasOwnProperty(file.mime)) mimes[file.mime] = [];
				mimes[file.mime].push(file);
			});

			for (var mime in mimes) {
				if (!mimes.hasOwnProperty(mime)) continue;

				var sizes = mimes[mime],
					size;

				if	(sizes.length >= 2) {
					sizes = sizes.filter(function(size, index, arr) {
						return size.width >= width;
					});
				}

				size = (sizes.length > 0) ? sizes[sizes.length - 1] : mimes[mime][0];
				sources += '<source src="' + size.file + '" type="' + mime + '">';
			}

			if (this.threshold > vpWidth()) {
				elem.setAttribute('preload', 'metadata');
			}

			elem.addEventListener('loadedmetadata', function() {
				elem.classList.remove('is-loading');
			});

			elem.innerHTML = sources;
			elem.classList.remove('lazy');
			elem.removeAttribute('data-sources');
			elem.style.height = '';
		}

		loadVideosNow(wrapper) {
			wrapper = wrapper || document;

			var videos = wrapper.querySelectorAll('video.lazy');
			[].forEach.call(videos, (function(video) {
				this.loadVideo(video);
			}).bind(this));
		}

		registerEvents() {
			window.addEventListener('scroll', (function() { this.checkVisibility(); }).bind(this), { passive: false });
			window.addEventListener('resize', (function() { this.checkVisibility(); }).bind(this), false);
		}
	}







	/***************************************
		Horizontal header menu
	***************************************/

	var horizontalHeaderMenu = function() {
		let elem = document.querySelector('.header.hide-menu');
		if (!elem) return;

		let threshold = 0.05;

		let lastScrollPosition = getScrollPos();

		let update = function() {
			let newScrollPosition = getScrollPos();

			if (newScrollPosition < lastScrollPosition - threshold * vpHeight()) {
				elem.classList.remove('hide');
				lastScrollPosition = newScrollPosition;
			} else if (newScrollPosition > lastScrollPosition) {
				lastScrollPosition = newScrollPosition;
				if (newScrollPosition > vpHeight()) {
					elem.classList.add('hide');
				}
			}
		};

		update();
		window.addEventListener('scroll', update);
		document.addEventListener('resize', update);
	}




	/***************************************
		Toggle Menu
	***************************************/

	var toggleMenu = function() {
		var header = document.querySelector('.header');
		if (!header) return;

		var	menu   = header.querySelector('.header-menu');
		if (!menu) return;

		let threshold = 90,
			toggle    = menu.querySelector('.header-menu-toggle');

		var toggleMenuVisibility = function() {
			header.classList.toggle('show-menu');
			if (header.classList.contains('show-menu')) {
				disableScroll();
			} else {
				enableScroll();
			}
		};

		var resize = function() {
			if (!header.classList.contains('show-menu')) return;

			if (vpWidth() >= threshold && !header.classList.contains('force-mobile-menu')) {
				header.classList.remove('show-menu');
				enableScroll();
			}
		}

		toggle.addEventListener('click', toggleMenuVisibility);
		window.addEventListener('resize', resize);
	}






	/***************************************
		Automatically switch burger menu
	***************************************/

	var autoSwitchMenu = function() {
		let elem       = document.querySelector('.header[data-autoswitchmenu="1"]');
		if (!elem) return;

		let	items       = [].slice.call(elem.querySelectorAll('.header-menu-inner > ul .menu-item')),
			threshold   = 1.5,
			maxWidthMin = 0;

		var update = function() {
			let width = vpWidth();

			if (width <= maxWidthMin) {
				elem.classList.add('force-mobile-menu');
			} else {
				elem.classList.remove('force-mobile-menu');

				let lineHeight = parseInt(getComputedStyle(items[0]).lineHeight.split('px')[0]),
					isWrapping = false;

				items.forEach(item => {
					isWrapping = isWrapping || item.offsetHeight >= lineHeight * threshold;
				});

				if (isWrapping && width > maxWidthMin) {
					maxWidthMin = width;
				}

				elem.classList.toggle('force-mobile-menu', isWrapping);
			}
		}

		update();
		window.addEventListener('resize', update);
	}






	/***************************************
		Expandable items
	***************************************/

	var expandableItems = function() {
		var elems = [].slice.call(document.querySelectorAll('.expandable'));
		if (!elems) return;

		elems.forEach(function(elem) {
			var toggles   = [].slice.call(elem.querySelectorAll('.expandable-toggle')),
				content   = elem.querySelector('.expandable-inner'),
				isVisible = false;

			var toggleState = function() {
				isVisible = !isVisible;
				elem.classList.toggle('show', isVisible);	
				toggles.forEach(toggle => toggle.innerText = toggle.getAttribute(isVisible ? 'data-content-active' : 'data-content-inactive') || toggle.innerText);
				resize();
			};

			var resize = function() {
				content.style.maxHeight = '';
				content.style.maxHeight = isVisible ? content.scrollHeight + 'px' : 0;
			};

			toggles.forEach(toggle => toggle.addEventListener('click', toggleState));
			window.addEventListener('resize', resize);

			resize();
		});
	};







	/***************************************
		Sliders
	***************************************/

	var sliders = function() {
		var elems = [].slice.call(document.querySelectorAll('.slider, .slider-mobile'));
		if (elems.length == 0) return;

		elems.forEach(elem => new Slider(elem));
	}


	class Slider {
		constructor(slider) {
			this.slider = slider;
			this.build();
		};

		build() {
			if (!this.slider) return;

			this.slideContainer	= this.slider.querySelector('.slider-slides, .slider-mobile-slides');
			if (!this.slideContainer) return this.cancelBuild();

			this.navContainer	       = this.slider.querySelector('.slider-nav, .slider-mobile-nav');
			this.slides			       = [].slice.call(this.slideContainer.querySelectorAll('.slide, .slider-mobile-slide'));
			this.buttons		       = [].slice.call(this.slider.querySelectorAll('.slider-btn, .slider-mobile-btn'));
			this.total			       = this.slides.length;
			this.currentSlide	       = 0;
			this.isMovingSlider        = this.slider.classList.contains('is-moving');
			this.isMobileOnly          = this.slider.classList.contains('slider-mobile');
			this.mobileDoubleThreshold = 650;
			this.mobileThreshold       = 1000;
			this.autoplay              = parseInt(this.slider.dataset.duration) || 0;
			this.autoplayTimer         = null;
			this.isSliding		       = false;


			if (this.total < 2) return this.cancelBuild();

			this.registerEvents();
			this.slideTo(0, true);
		}

		cancelBuild() {
			if (this.slider)
				this.slider.classList.add('aborted');
		}

		registerEvents() {
			var swipeDetected = this.swipeDetected.bind(this);
			this.swiper = new SwipeDetect(this.slider, swipeDetected, { stagger: 200, vertical: false });

			this.slider.addEventListener('mouseenter', this.mouseEnter.bind(this));
			this.slider.addEventListener('mouseleave', this.mouseLeave.bind(this));

			if (this.navContainer) {
				this.navContainer.querySelector('.nav-prev, .slider-mobile-nav-prev').addEventListener('click', this.prevSlide.bind(this));
				this.navContainer.querySelector('.nav-next, .slider-mobile-nav-next').addEventListener('click', this.nextSlide.bind(this));
			}

			if (this.buttons) {
				this.buttons.forEach((function(btn) {
					btn.addEventListener('click', (function() {
						this.slideTo(btn.dataset.index);
					}).bind(this));
				}).bind(this));
			}

			if (this.isMovingSlider || this.isMobileOnly) {
				window.addEventListener('resize', this.resize.bind(this));
			}

			document.addEventListener('keydown', this.keydown.bind(this));
		}

		resize() {
			let target = this.currentSlide;
			if (vpWidth() >= this.mobileThreshold && vpWidth() < this.mobileThreshold) {
				target = Math.floor(target / 2) * 2;
			}

			this.slideTo(target, true);
		}


		slideTo(target, force) {
			target = parseInt(target);
			if (target < 0)           target = this.total - 1;
			if (target >= this.total) target = 0;

			if (!force && (this.isSliding || target === this.currentSlide)) return;
			if (this.isMobileOnly && vpWidth() > this.mobileThreshold) return;

			this.isSliding = true;
			if (force) this.slideContainer.classList.add('no-transition');

			this.slides.forEach(slide => slide.dataset.index == target ? slide.classList.add('active') : null);

			if (this.isMovingSlider) {
				let offset = this.slides[target].offsetLeft;
				this.slideContainer.style.transform = 'translateX(-' + offset + 'px)';
			}

			this.buttons.forEach(btn  => btn.classList.toggle('active',     btn.dataset.index == target));
			this.slider.classList.toggle('is-first-slide', target == 0);
			this.slider.classList.toggle('is-last-slide', target == this.total - 1);
			imgPreloader.checkVisibility();
			vidPreloader.checkVisibility();

			this.slides.forEach(slide => slide.classList.toggle('active', slide.dataset.index == target));
			this.currentSlide = target;
			this.isSliding = false;

			if (this.autoplay !== 0) {
				clearTimeout(this.autoplayTimer);
				this.autoplayTimer = setTimeout(this.nextSlide.bind(this), this.autoplay);
			}			

			if (force) 
				setTimeout((() => this.slideContainer.classList.remove('no-transition')).bind(this), 400);
		}

		prevSlide() {
			let target = this.isMobileOnly && vpWidth() >= this.mobileDoubleThreshold
					   ? Math.floor(this.currentSlide / 2) * 2 - 2
					   : this.currentSlide - 1;

			this.slideTo(target);
		}

		nextSlide() {
			let target = this.isMobileOnly && vpWidth() >= this.mobileDoubleThreshold
					   ? Math.floor(this.currentSlide / 2) * 2 + 2
					   : this.currentSlide + 1;

			this.slideTo(target);
		}

		swipeDetected(e) {
			if (e.directionX == 0) return;				

			var directionDegrees = e.direction2D * 180 / Math.PI + 90;		// down: 0°, clockwise

			while (directionDegrees <=   0) directionDegrees += 360;
			while (directionDegrees >= 360) directionDegrees -= 360;

			var	isRight          = directionDegrees >= 225 && directionDegrees <= 315,
				isLeft           = directionDegrees >= 45  && directionDegrees <= 135;

			if (isRight) 	this.prevSlide();
			if (isLeft) 	this.nextSlide();
		}

		keydown(e) {
			if (!this.isSliderVisible()) return;
			
			let key = e.keyCode;
			
			if (key == 37)	this.prevSlide();			// arrow left
			if (key == 39)	this.nextSlide();			// arrow right
		}

		mouseEnter() {
			if (this.autoplay === 0) return;
			
			clearTimeout(this.autoplayTimer);
		}

		mouseLeave() {
			if (this.autoplay === 0) return;
			
			this.autoplayTimer = setTimeout(this.nextSlide.bind(this), this.autoplay);	
		}


		isSliderVisible() {
			let rect = this.slider.getBoundingClientRect()
			return -rect.top < rect.height && rect.bottom < rect.height + vpHeight()
			    && -rect.left < rect.width && rect.right < rect.width + vpWidth();
		}
	}






	/***************************************
		Resize iframes
	***************************************/

	var resizeIframes = function(parent) {
		parent = parent || document;

		var containers = parent.querySelectorAll('.module:not(.module-youtube) .video-container');
		if (!containers) return;

		var sizeThis = function() {
			[].forEach.call(containers, function(container) {

				var iframe = container.querySelector('iframe:not(.video-embed-player), embed:not(.video-embed-player)');
				if (!iframe) return;

				var parent      = container.parentNode,
					width       = iframe.getAttribute('width'),
					height      = iframe.getAttribute('height');

				if (isNaN(width) || isNaN(height)) {
					while (container.firstChild) parent.insertBefore(container.firstChild, container);
					parent.removeChild(container);
					return;
				}

				var	ratio        = width / height,
					parentWidth  = parent.offsetWidth,
					parentHeight = parent.offsetHeight,
					parentRatio  = parentWidth / parentHeight;

				container.classList.remove('full-width', 'full-height');
				container.style.paddingBottom = '';
				container.style.paddingLeft = '';

				if (ratio >= parentRatio) {
					container.classList.add('full-width');
					container.style.paddingBottom = (100 / ratio) + '%';
				} else {
					container.classList.add('full-height');
					container.style.paddingLeft = (ratio * parentHeight) + 'px';
					container.style.paddingBottom = parentHeight + 'px';
				}
			});
		}

		sizeThis();
		window.addEventListener('resize', sizeThis);
	}




	/***************************************
		Contact form
	***************************************/

	var contactForms = function() {
		var elems = [].slice.call(document.querySelectorAll('.module-contactform'));
		if (!elems) return;

		elems.forEach(function(elem) {
			var form       = elem.querySelector('form'),
				parent     = form.parentElement,
				fields     = [].slice.call(form.querySelectorAll('input, select, textarea')),
				submit     = form.querySelector('.form-submit'),
				formMsg    = parent.querySelector('.form-message'),
				postID     = elem.dataset.parentId,
				formID     = elem.dataset.moduleId,
				allValid   = false;
			
			var checkValidity = function() {
				allValid = true;
				formMsg.innerHTML = '';
				form.classList.remove('submit-success');

				fields.forEach(function(field) {
					var parent     = field.closest('.form-field'),
						label      = parent.querySelector('label'),
						errorMsg   = parent.querySelector('.field-error'),
						validity   = field.validity,
						isValid    = validity.valid,
						isRequired = field.required,
						isEmpty    = field.value == '' || field.value == '-1',
						name       = field.dataset.title,
						errorText  = '';

				//	honeypot for spam bots, should not be validated
					if (name == 'familyname')
						return;

					parent.classList.remove('invalid', 'valid');

					if (isValid && isRequired && !isEmpty) {
						parent.classList.add('valid');
						return;
					}

					if (name !== 'disclaimer') {
						if (validity.valueMissing)
							errorText = localisedfuscf['empty' + name];
						if (validity.patternMismatch || validity.typeMismatch)
							errorText = localisedfuscf['wrong' + name];

						let toggleError =  (!isEmpty && !isValid);

						errorMsg.innerHTML = toggleError ? errorText : '';
						parent.classList.toggle('invalid', toggleError);
					}

					allValid = allValid && (isValid && (!isRequired || !isEmpty));
				});

				submit.classList.toggle('disabled', !allValid);
			};

			var submitForm = function(e) {
				e.preventDefault();
				if (submit.classList.contains('disabled'))
					return;

				checkValidity();
				if (!allValid) return;

				var url     = new URL(window.location.href),
					data    = fields.map(function(field) {
						var name  = field.type == 'checkbox' ? field.name : field.getAttribute('data-title'),
							value = field.type == 'checkbox' ? field.checked : field.value || field.innerText;

						return name + '=' + value;
					}),
					xhr     = xhrCors('POST', localisedfus.ajaxurl, true),
					action  = 'contactform',
					request = 'action=' + action + '&postID=' + postID + '&formID=' + formID + '&' + data.join('&'),
					success = '<h3 class="success-title beta">' + localisedfuscf.successTitle + '</h3><h4 class="success-text beta">' + localisedfuscf.successText + '</h4>';

				xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

				xhr.onreadystatechange = function() {
					let text = this.responseText.trim();
					if (text == '') return;
										
					formMsg.innerHTML = text == 'success' ? success : text;
					form.classList.add('submit-success');
					formMsg.classList.add('show');
					form.blur();
				};
		
				xhr.send(encodeURI(request));

				setTimeout(function() {
					formMsg.innerHTML = success;
					form.classList.add('submit-success');
				}, 300);
			};

			fields.forEach(field => field.addEventListener('input', checkValidity));
			submit.addEventListener('click', submitForm);
			form.addEventListener('submit', submitForm);
		});
	};





	/***************************************
		Prevent Scroll
	***************************************/

	var preventDefaultScroll = function(e) {
		e = e || window.event;
		if (e.preventDefault)
			e.preventDefault();
		e.returnValue = false;
	};

	var preventDefaultForScrollKeys = function(e) {
		var keys = { 37: 1, 38: 1, 39: 1, 40: 1 };
		if (keys[e.keyCode]) {
			preventDefaultScroll(e);
			return false;
		}
	}

	var disableScroll = function() {
		var wheelOpt = supportsPassiveEvents() ? { passive: false } : false,
			wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';

		window.addEventListener('DOMMouseScroll', preventDefaultScroll, false);
		window.addEventListener(wheelEvent, preventDefaultScroll, wheelOpt);
		window.addEventListener('touchmove', preventDefaultScroll, wheelOpt);
		window.addEventListener('keydown', preventDefaultForScrollKeys, false);
	}

	var enableScroll = function() {
		var wheelOpt = supportsPassiveEvents() ? { passive: false } : false,
			wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';

		window.removeEventListener('DOMMouseScroll', preventDefaultScroll, false);
		window.removeEventListener(wheelEvent, preventDefaultScroll, wheelOpt);
		window.removeEventListener('touchmove', preventDefaultScroll, wheelOpt);
		window.removeEventListener('keydown', preventDefaultForScrollKeys, false);
	}

	var supportsPassiveEvents = function() {
		var supportsPassive = false;

		try {
			window.addEventListener('test', null, Object.defineProperty({}, 'passive', {
				get: function() { supportsPassive = true; }
			}));
		} catch(e) {}

		return supportsPassive;
	}



	/***************************************
		Show language sub menu
	***************************************/

	var showLanguageSubMenu = function() {
		var elems = [].slice.call(document.querySelectorAll('.header-menu-languages'));
		if (elems.length == 0) return;

		elems.forEach(elem => {
			var toggle = elem.querySelector('.lang-chevron');

			var toggleNow = function() {
				elem.classList.toggle('show');
			}

			if (toggle)
				toggle.addEventListener('click', toggleNow);
		});
	}



	




	/***************************************
		Register map
	***************************************/

	var registerMap = function() {
		var elem = document.querySelector('.module-map');
		if (!elem || mapOptions.mapbox == '') return;

		var container = elem.querySelector('.map-inner');

		if (typeof mapboxgl === 'undefined')
			return setTimeout(registerMap, 100);

		mapboxgl.accessToken = mapOptions.mapbox;

		var center = mapOptions.longitude !== '' &&  mapOptions.latitude !== ''
				   ? [mapOptions.longitude, mapOptions.latitude] : [],
			map = new mapboxgl.Map({
				attributionControl: false,
				center: center,
				container: container,
				style: mapOptions.mapStyle,
				zoom: 13,
				maxBounds: [
					[-180, -90],
					[180, 90]
				],
			}),
			lang = document.documentElement.lang,
			language = new MapboxLanguage({ defaultLanguage: lang.replace(/-(\S+)/g, '') }),
			markerElem = document.createElement('div'),
			marker = new mapboxgl.Marker(markerElem)
				.setLngLat(center)
				.addTo(map);

		markerElem.classList.add('map-marker');
		map.addControl(new mapboxgl.NavigationControl(), 'bottom-right');
		map.addControl(language);

		map.on('load', function() {

		});
	}




	/***************************************
		Toggle collapsibles
	***************************************/

	var toggleCollapsibles = function() {
		var collapsibles = [].slice.call(document.querySelectorAll('.collapsible'));
		if (!collapsibles) return;

		var headerThreshhold = 900;

		var collapseThis = function(item) {
			var body      = item.querySelector('.collapsible-body');

			var maxHeight = body.style.maxHeight === '' || parseInt(body.style.maxHeight) == 0 ? body.scrollHeight : 0;

			body.style.maxHeight = maxHeight + 'px';

			collapsibles.forEach(function(otherItem) {
				otherItem.classList.remove('current-menu');
				otherItem.classList.toggle('content-shown', otherItem == item && maxHeight !== 0);
				if (otherItem !== item)
					otherItem.querySelector('.collapsible-body').style.maxHeight = '0px';
			});
		};

		var resize = function() {
			collapsibles.forEach(function(item) {
				var body = item.querySelector('.collapsible-body');
				body.style.maxHeight = '';
			});
		};

		collapsibles.forEach(function(item) {
			var body      = item.querySelector('.collapsible-body');

			var toggle = item.querySelector('.collapsible-header');
			toggle.addEventListener('click', function() { collapseThis(item); });

		//	start with opened boxes sometimes
			if (item.classList.contains('start-open')) {
				item.classList.remove('start-open');
				collapseThis(item);
			}
		});

		resize();
		window.addEventListener('resize', resize);
	}





	/***************************************
		Videos
	***************************************/

	var videos = function() {
		var elems = [].slice.call(document.querySelectorAll('.module-video'));
		if (!elems) return;


		class VideoPlayer {
			constructor(elem) {
				this.id                     = Math.random();
				this.baseVolume             = 0.8;
				this.blockScrollKeys        = false;
				this.hideControlsOnPlay     = true;
				this.hideControlsDelay      = 2000;

				this.elem                   = elem;
				this.type                   = null;
				this.player                 = null;
				this.registerVideoType();

				if (!this.player) return;

				this.width                  = this.player.width;
				this.height                 = this.player.height;
				this.fullscreenHandlers     = [];

				this.hasLoaded              = false;
				this.hasTriggeredFullscreen = false;
				this.isAutoplay             = this.player.isAutoplay;
				this.isMuted                = this.isAutoplay;
				this.startMuted             = this.isMuted;
				this.isPlaying              = null;
				this.isSeekingByProgressBar = false;
				this.isVolumeByVolumeBar    = false;
				this.isLoaded               = false;
				this.isLoading              = false;
				this.currentTime            = 0;
				this.duration               = null;
				this.volume                 = this.baseVolume;

				this.ui                     = {
					playPause:         this.elem.querySelector('.btn-play-pause'),
					currentTime:       this.elem.querySelector('.current-time'),
					totalTime:         this.elem.querySelector('.total-time'),
					volumeBar:         this.elem.querySelector('.volume-bar'),
					volumeBarInner:    this.elem.querySelector('.volume-bar-inner'),
					muteButton:        this.elem.querySelector('.btn-mute'),
					fsButton:          this.elem.querySelector('.btn-fullscreen'),
					progressBar:       this.elem.querySelector('.progress-bar'),
					progressBarBuffer: this.elem.querySelector('.progress-bar-buffer'),
					progressBarTime:   this.elem.querySelector('.progress-bar-time')
				};

				this.prepareVideo();
				this.findFullScreenHandlers();

				this.setVolume(this.volume);

				if (this.startMuted)
					this.mute(true);

				this.registerEvents();
			}

			registerVideoType() {
				let classes = this.elem.classList;
				if (classes.contains('module-native-video')) {
					this.type = 'native';
					this.player = new NativeVideoPlayer(this.elem, this);
				} else if (classes.contains('module-vimeo')) {
					this.type = 'vimeo';
					this.player = new VimeoPlayer(this.elem, this);
				} else if (classes.contains('module-youtube')) {
					this.type = 'youtube';
					this.player = new YouTubePlayer(this.elem, this);
					youTubeInstances.push(this.player);
				}
			}

			registerEvents() {
				window.addEventListener('resize',                      this.checkVisibility.bind(this), false);
				window.addEventListener('scroll',                      this.checkVisibility.bind(this), { passive: false });
				window.addEventListener('scroll',                      this.pausePlayerOnScroll.bind(this));


			/*	Keyboard */
				document.addEventListener('keydown',                   this.keyDownHandler.bind(this));

			/*	Mouse events */
				if (this.ui.playPause)
					this.ui.playPause.addEventListener('click',        this.togglePlayPause.bind(this));

				if (this.ui.fsButton)
					this.ui.fsButton.addEventListener( 'click',        this.toggleFullScreen.bind(this));

				if (this.ui.muteButton)
					this.ui.muteButton.addEventListener('click',       this.toggleMute.bind(this));

				if (this.ui.volumeBar) {
					this.ui.volumeBar.addEventListener('mousedown',    this.volumeByVolumeBarStart.bind(this));
					this.ui.volumeBar.addEventListener('mousemove',    this.volumeByVolumeBar.bind(this));
					this.ui.volumeBar.addEventListener('mouseup',      this.volumeByVolumeBarEnd.bind(this));

					this.ui.volumeBar.addEventListener('touchstart',   this.volumeByVolumeBarStart.bind(this));
					this.ui.volumeBar.addEventListener('touchmove',    this.volumeByVolumeBar.bind(this));
					this.ui.volumeBar.addEventListener('touchend',     this.volumeByVolumeBarEnd.bind(this));
				}

				if (this.ui.progressBar) {
					this.ui.progressBar.addEventListener('mousedown',  this.seekByProgressBarStart.bind(this));
					this.ui.progressBar.addEventListener('mousemove',  this.seekByProgressBar.bind(this));
					this.ui.progressBar.addEventListener('mouseup',    this.seekByProgressBarEnd.bind(this));

					this.ui.progressBar.addEventListener('touchstart', this.seekByProgressBarStart.bind(this));
					this.ui.progressBar.addEventListener('touchmove',  this.seekByProgressBar.bind(this));
					this.ui.progressBar.addEventListener('touchend',   this.seekByProgressBarEnd.bind(this));
				}

				if (this.hideControlsOnPlay) {
					this.elem.addEventListener('mouseenter',           this.showControls.bind(this));
					this.elem.addEventListener('mousemove',            this.hideControlsFullscreen.bind(this));
					this.elem.addEventListener('mouseleave',           this.hideControls.bind(this));
				}

				document.addEventListener('mouseup',                   this.releaseAllMouseDownHandlers.bind(this));
			}

			findFullScreenHandlers() {
				let d        = document,
					e        = d.documentElement,
					handlers = {
						callOnVideo: false,
						isFullscreenVideo: this.player.isFullscreenVideo,
						isFullscreen: () => d.fullscreen || d.fullScreen || d.webkitIsFullScreen || d.mozFullScreen || d.msFullscreenElement || false
					};

				     if (e.requestFullScreen)					handlers.request = e.requestFullScreen;
				else if (e.mozRequestFullScreen)				handlers.request = e.mozRequestFullScreen;
				else if (e.webkitRequestFullScreen)				handlers.request = e.webkitRequestFullScreen;
				else if (e.webkitRequestFullscreen)				handlers.request = e.webkitRequestFullscreen;
				else if (e.webkitEnterFullScreen)				handlers.request = e.webkitEnterFullScreen;
				else if (e.msRequestFullscreen)					handlers.request = e.msRequestFullscreen;
				else if (e.requestFullscreen)					handlers.request = e.requestFullscreen;
				else if (this.player.webkitEnterFullscreen) {
					handlers.request = this.player.webkitEnterFullscreen;
					handlers.callOnVideo = true;
				}

					 if (d.exitFullscreen)					handlers.exit    = d.exitFullscreen;
				else if (d.mozCancelFullScreen)				handlers.exit    = d.mozCancelFullScreen;
				else if (e.webkitExitFullScreen)			handlers.exit    = e.webkitExitFullScreen;
			  	else if (d.webkitExitFullscreen)			handlers.exit    = d.webkitExitFullscreen;
				else if (d.msExitFullscreen)				handlers.exit    = d.msExitFullscreen;
				else if (this.player.webkitExitFullScreen)	{
					handlers.exit = this.player.webkitExitFullScreen;
					handlers.callOnVideo = true;
				}

				document.addEventListener('fullscreenchange',       this.onFullscreenChange.bind(this));
				document.addEventListener('mozfullscreenchange',    this.onFullscreenChange.bind(this));
				document.addEventListener('webkitfullscreenchange', this.onFullscreenChange.bind(this));
				document.addEventListener('MSFullscreenChange',     this.onFullscreenChange.bind(this));

				this.fullscreenHandlers = handlers;
			}

			keyDownHandler(e) {
				if (!this.isPlayerVisible()) return;
				if (e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return;

				let code           = e.keyCode,
					preventDefault = true;

				switch (code) {
					case 27: 		// Escape
						this.exitFullscreen();
						break;
					case 32: 		// space bar
						preventDefault = !this.blockScrollKeys;
						if (preventDefault) this.togglePlayPause();
						break;
					case 37: 		// arrow left
						this.seekTo(this.currentTime - 5);
						break;
					case 38: 		// arrow top
						preventDefault = !this.blockScrollKeys;
						if (preventDefault) this.setVolume(this.volume + 0.1);
						break;
					case 39: 		// arrow right
						this.seekTo(this.currentTime + 5);
						break;
					case 40: 		// arrow bottom
						preventDefault = !this.blockScrollKeys;
						if (preventDefault) this.setVolume(this.volume - 0.1);
						break;
					case 48: 		// 0-9
					case 49:
					case 50:
					case 51:
					case 52:
					case 53:
					case 54:
					case 55:
					case 56:
					case 57:
						this.seekTo(this.duration * 0.1 * (code - 48))
						break;
					case 70: 		// F
						this.toggleFullScreen();
						break;
					case 74: 		// J
						this.seekTo(this.currentTime - 10);
						break;
					case 75: 		// K
						this.togglePlayPause();
						break;
					case 76: 		// L
						this.seekTo(this.currentTime + 10);
						break;
					case 77: 		// M
						this.toggleMute();
						break;
					default:
						preventDefault = false;
						break;
				}

				if (preventDefault)
					e.preventDefault();
			}



			/************************************************
			 * Video event listeners
			 * **********************************************/

			onEnded(e) {
				this.seekTo(0);
			}

			onLoaded(e) {
				this.elem.classList.add('has-loaded');
				this.elem.classList.remove('is-loading');

				this.duration  = this.player.duration;
				this.hasLoaded = true;
				this.isLoading = false;
				this.isLoaded  = true;

				if (this.ui.currentTime)
					this.ui.currentTime.innerText = this.formatTime(0);

				if (this.ui.totalTime)
					this.ui.totalTime.innerText = this.formatTime(this.duration);

				if (this.ui.currentTime || this.ui.totalTime) {
					this.elem.classList.remove('time-segments-1', 'time-segments-2', 'time-segments-3');
					this.elem.classList.add('time-segments-' + this.getDurationSectionsAmount());
				}

				if (this.isAutoplay)
					this.isPlaying = true;
			}

			onPaused(e) {
				this.isPlaying = false;
				this.elem.classList.remove('is-playing');
			}

			onPlayerError(e) {
				console.warn(e);
			}

			onPlaying(e) {
				this.isPlaying = true;
				this.elem.classList.add('is-playing');
			}

			onProgress(sections) {
				if (!this.ui.progressBarBuffer) return;

				let canvas    = this.ui.progressBarBuffer,
					context   = canvas.getContext('2d'),
					increment = canvas.width / this.duration;

				context.clearRect(0, 0, canvas.width, canvas.height);
				context.fillStyle = '#fff';

				for (let i = 0; i < sections.length; i++) {
					let start = sections[i].start,
						end   = sections[i].end,
						width = (end - start) * increment;

					context.fillRect(start, 0, width, canvas.height);
				}
			}

			onTimeUpdate(e) {
				this.currentTime = this.player.currentTime;

				if (this.ui.currentTime)
					this.ui.currentTime.innerText = this.formatTime(this.currentTime)
				if (this.ui.progressBarTime)
					this.ui.progressBarTime.style.width = (100 * this.currentTime / this.duration) + '%';
			}

			onVolumeChange(e) {
				this.isMuted = this.player.isMuted;
				this.elem.classList.toggle('is-muted', this.isMuted);
			}



			/************************************************
			 * 	Preparing and loading appropriate version
			 * **********************************************/

			prepareVideo() {
				if (this.type == 'youtube') return;

				let parentWidth = this.elem.scrollWidth,
					newHeight   = this.height * parentWidth / this.width;

				this.player.setHeight(newHeight);
			}

			checkVisibility() {
				if (this.loaded) return;

				debounce((function() {
					if (this.isPlayerVisible())
						this.loadVideo();

				}).bind(this));
			}

			loadVideo() {
				if (this.type == 'youtube') return;
				this.player.loadVideo();
			}



			/************************************************
			 * 	Event listeners
			 * **********************************************/

			onFullscreenChange(e) {
				if (!this.hasTriggeredFullscreen) return;

				let isFullScreen = this.isFullscreen();
				if (isFullScreen)	disableScroll();
				else  				enableScroll();

				document.body.classList.toggle('is-fullscreen', isFullScreen);
				this.elem.classList.toggle('is-fullscreen', isFullScreen);

				if (!isFullScreen) {
					let behaviorSupported = 'scrollBehavior' in document.documentElement.style,
						videoPos          = this.elem.getBoundingClientRect(),
						scrollTop         = getScrollPos(),
						scrollLeft        = window.pageXOffset || document.documentElement.scrollLeft,
						top               = videoPos.top + scrollTop - 0.5 * (vpHeight() - videoPos.height),
						left              = videoPos.left + scrollLeft - 0.5 * (vpWidth() - videoPos.width);

					if (false)	window.scrollTo({ top: top, left: left, behavior: 'smooth' });
					else  					window.scrollTo(left, top);

					this.hasTriggeredFullscreen = false;
				}
			}



			/************************************************
			 * 	Controls
			 * **********************************************/

			exitFullscreen() {
				if (!this.isFullscreen() || !this.fullscreenHandlers.exit) return;

				if (this.fullscreenHandlers.callOnVideo)	this.fullscreenHandlers.exit();
				else 										this.fullscreenHandlers.exit.call(document);

				this.elem.classList.remove('is-fullscreen');
			}

			isFullscreen() {
				return !!(this.fullscreenHandlers.isFullscreen());
			//	return !!(this.fullscreenHandlers.callOnVideo ? this.video.webkitDisplayingFullscreen : this.fullscreenHandlers.isFullscreen());
			}

			mute(initialOverride = false) {
				if (this.isMuted && !initialOverride) return;

				this.oldVolume = this.volume;
				this.setVolume(0);
				this.player.mute();
				this.isMuted = true;
				this.elem.classList.add('is-muted');
				this.hideControlsFullscreen();
			}

			pause() {
				if (!this.isPlaying) return;
				this.player.pause();
				this.showControls();
			}

			play() {
				if (this.isPlaying) return;
				this.player.play();
				this.hideControlsFullscreen();

				if (!this.elem.classList.contains('has-played')) {
					this.elem.classList.add('has-played');

					this.isPlaying = true;
					this.showControls();
				}
			}

			requestFullscreen() {
				if (this.isFullscreen() || !this.fullscreenHandlers.request) return;

				this.hasTriggeredFullscreen = true;

				if (this.fullscreenHandlers.callOnVideo)	this.video.webkitEnterFullscreen();
				else 										this.fullscreenHandlers.request.call(document.documentElement);

				this.elem.classList.add('is-fullscreen');
				this.hideControlsFullscreen();
			}

			stop() {
				this.player.pause();
			}

			seekTo(time) {
				time = this.minmax(time, 0, this.duration);
				this.player.seekTo(time);
			}

			setVolume(volume) {
				this.volume = this.minmax(volume, 0, 1);
				this.player.setVolume(this.volume);
				this.isMuted = false;

				if (this.ui.volumeBarInner)
					this.ui.volumeBarInner.style.transform = 'scaleX(' + this.volume + ')';
			}

			unmute() {
				if (!this.isMuted) return;
				this.setVolume(this.oldVolume ? this.oldVolume : this.baseVolume);
				this.player.unmute();
				this.isMuted = false;
				this.elem.classList.remove('is-muted');
				this.hideControlsFullscreen();
			}



			/************************************************
			 * 	UI controls
			 * **********************************************/

			hideControls() {
				if (!this.hideControlsOnPlay) return;

				this.controlsTimeout = setTimeout((() => {
					if (!this.isPlaying) return;
					this.elem.classList.add('hide-controls');
				}).bind(this), this.hideControlsDelay);
			}

			hideControlsFullscreen() {
				if (!this.hideControlsOnPlay || !this.isFullscreen()) return;

				this.showControls();
				this.hideControls();
			}

			pausePlayerOnScroll() {
				if (this.isPlayerVisible()) return;
				this.pause();
			}

			releaseAllMouseDownHandlers() {
				this.isSeekingByProgressBar = false;
				this.isVolumeByVolumeBar    = false;
			}

			seekByProgressBarStart() {
				this.isSeekingByProgressBar = true;
			}

			seekByProgressBar(e) {
				if (!this.isSeekingByProgressBar) return;

				let seekPercentage = this.getProgressPercentage(e, this.ui.progressBar);
				this.seekTo(seekPercentage * this.duration);
			}

			seekByProgressBarEnd(e) {
				this.seekByProgressBar(e);
				this.isSeekingByProgressBar = false;
				this.hideControlsFullscreen();
			}

			showControls() {
				if (!this.hideControlsOnPlay || this.isPlaying === null) return;

				this.elem.classList.remove('hide-controls');
				if (this.controlsTimeout)
					clearTimeout(this.controlsTimeout);
			}

			toggleFullScreen() {
				if (this.isFullscreen())	this.exitFullscreen();
				else  						this.requestFullscreen();
			}

			toggleMute() {
				if (this.isMuted)	this.unmute();
				else  				this.mute();
			}

			togglePlayPause() {
				if (this.isPlaying)	this.pause();
				else  				this.play();
			}

			volumeByVolumeBarStart() {
				this.isVolumeByVolumeBar = true;
			}

			volumeByVolumeBar(e) {
		
				if (!this.isVolumeByVolumeBar) return;

				let volumePercentage = this.getProgressPercentage(e, this.ui.volumeBar);

				this.setVolume(volumePercentage);
				this.isMuted = volumePercentage == 0;
				this.elem.classList.toggle('is-muted', volumePercentage == 0);
			}

			volumeByVolumeBarEnd(e) {
				this.volumeByVolumeBar(e);
				this.isVolumeByVolumeBar = false;
				this.hideControlsFullscreen();
			}



			/************************************************
			 * 	Helper functions
			 * **********************************************/

			formatTime(time) {
				let amountSections = this.getDurationSectionsAmount(),
					hours          = String(Math.floor(time / 3600)).padStart(2, '0'),
					minutes        = String(Math.floor(time / 60 % 60)).padStart(2, '0'),
					seconds        = String(Math.floor(time % 60)).padStart(2, '0');

				return [hours, minutes, seconds].slice(3 - amountSections).join(':');
			}

			getDurationSectionsAmount() {
				return this.duration >= 3600 ? 3 : 2;
			}

			getProgressPercentage(e, elem) {
				let x     = 0,
					rect = elem.getBoundingClientRect();

				if (e.type == 'touchmove' || e.type == 'touchend') {
					let event = (typeof e.originalEvent === 'undefined') ? e : e.originalEvent,
						touch = event.touches[0] || event.changedTouches[0];
					x = touch.clientX - rect.left;
				} else if (e.type == 'mouseup' || e.type == 'mousemove') {
					x = e.layerX;
				}

				return x / rect.width;
			}

			isPlayerVisible() {
				let rect = this.elem.getBoundingClientRect()
				return -rect.top < rect.height && rect.bottom < rect.height + vpHeight()
				    && -rect.left < rect.width && rect.right < rect.width + vpWidth();
			}

			minmax(value, min, max) {
				return Math.max(Math.min(value, max), min);
			}
		}



		/************************************************
		* 	Native Video Player
		* **********************************************/

		class NativeVideoPlayer {
			constructor(elem, parent) {
				this.threshold  = 500;

				this.parent     = parent;
				this.elem       = elem;
				this.video      = elem.querySelector('video');
				this.sources    = this.video.dataset.sources;
				if (!this.sources) return;

				this.sources    = JSON.parse(this.sources);
				this.width      = this.video.width;
				this.height     = this.video.height;

				this.duration   = null;
				this.isAutoplay = this.video.autoplay == '1';
				this.isMuted    = this.isAutoplay;
				this.volume     = this.parent.baseVolume;

				this.parent.checkVisibility();
				this.registerEvents();
			}

			registerEvents() {
				this.video.addEventListener('ended',               this.onEnded.bind(this));
				this.video.addEventListener('error',               this.onPlayerError.bind(this));
				this.video.addEventListener('loadedmetadata',      this.onLoaded.bind(this));
				this.video.addEventListener('pause',               this.onPaused.bind(this));
				this.video.addEventListener('play',                this.onPlaying.bind(this));
				this.video.addEventListener('progress',            this.onProgress.bind(this));
				this.video.addEventListener('timeupdate',          this.onTimeUpdate.bind(this));
				this.video.addEventListener('volumechange',        this.onVolumeChange.bind(this));

				this.video.addEventListener('click',               this.parent.togglePlayPause.bind(this.parent));

				this.video.addEventListener('webkitendfullscreen', this.parent.onFullscreenChange.bind(this));
				this.video.addEventListener('fullscreenchange',    this.parent.onFullscreenChange.bind(this));
			}

			loadVideo() {
				if (this.parent.isLoading || this.parent.hasLoaded) return;

				this.parent.isLoading = true;
				this.elem.classList.add('is-loading');

				let mimes   = {},
					sources = '';

				this.sources.forEach(file => {
					if (!mimes.hasOwnProperty(file.mime))
						mimes[file.mime] = [];
					mimes[file.mime].push(file);
				});

				for (let mime in mimes) {
					if (!mimes.hasOwnProperty(mime)) continue;

					let sizes = mimes[mime],
						size;

					if (sizes.length >= 2) {
						sizes = sizes.filter(((size, index, arr) => size.width >= this.width).bind(this));
					}

					size     = (sizes.length > 0) ? sizes[sizes.length - 1] : mimes[mime][0];
					sources += '<source src="' + size.file + '" type="' + mime + '">';
				}

				if (this.threshold > vpWidth()) {
					this.video.setAttribute('preload', 'metadata');
				}

				this.video.innerHTML = sources;
				this.video.removeAttribute('data-sources');
				this.video.style.height = '';

				window.removeEventListener('scroll', this.parent.checkVisibility.bind(this));
				window.removeEventListener('resize', this.parent.checkVisibility.bind(this));
			}

			setHeight(newHeight) {
				this.video.style.height = newHeight + 'px';
			}



			/************************************************
			 * Video event listeners
			 * **********************************************/

			onEnded(e) {
				this.parent.onEnded(e);
			}

			onLoaded(e) {
				this.video.setAttribute('playsinline', 'playsinline');
				this.duration = this.video.duration;
				this.parent.onLoaded(e);
			}

			onPaused(e) {
				this.parent.onPaused(e);
			}

			onPlayerError(e) {
				this.parent.onPlayerError(e);
			}

			onPlaying(e) {
				this.parent.onPlaying();
			}

			onProgress() {
				let sections = [];

				for (let i = 0; i < this.video.buffered.length; i++) {
					sections.push({ start: this.video.buffered.start(i), end: this.video.buffered.end(i) });
				}

				this.parent.onProgress(sections);
			}

			onTimeUpdate(e) {
				this.currentTime = this.video.currentTime;
				this.parent.onTimeUpdate(e);
			}

			onVolumeChange(e) {
				this.isMuted = this.video.muted && this.video.volume == 0;
				this.volume  = this.video.volume;
				this.parent.onVolumeChange(e);
			}



			/************************************************
			 * Fullscreen functions
			 * **********************************************/

			isFullscreenVideo = () => this.video.webkitDisplayingFullscreen;
			webkitEnterFullscreen = () => this.video.webkitEnterFullscreen;
			webkitExitFullScreen = () => this.video.webkitExitFullScreen;



			/************************************************
			 * 	Controls
			 * **********************************************/

			mute = () => this.video.muted = true;
			play = () => this.video.play();
			pause = () => this.video.pause();
			seekTo = (time) => this.video.currentTime = time;
			setVolume = (volume) => this.video.volume = volume;
			stop = () => this.video.pause();
			unmute = () => this.video.muted = false;
		}








		/************************************************
		* 	Vimeo Player
		* **********************************************/

		class VimeoPlayer {
			constructor(elem, parent) {
				this.threshold  = 500;

				this.parent     = parent;
				this.elem       = elem;
				this.inner      = elem.querySelector('.video-inner');
				this.id         = this.inner.dataset.id;
				if (!this.id) return;

				this.duration   = null;
				this.isAutoplay = this.inner.dataset.autoplay == '1';
				this.isLooping  = this.inner.dataset.loop == '1';
				this.isMuted    = this.isAutoplay;
				this.startMuted = this.isMuted;
				this.volume     = this.parent.baseVolume;

				this.vimeoOptions = {
					autoplay:    this.isAutoplay,
					byline:      false,
					controls:    false,
					dnt:         true,
					id:          this.id,
					keyboard:    false,
					loop:        this.isLooping,
					muted:       this.startMuted,
					playsinline: true,
					portrait:    false,
					width:       this.inner.clientWidth,
				};

				this.player     = new Vimeo.Player(this.inner, this.vimeoOptions);

				this.parent.checkVisibility();
				this.registerEvents();
			}

			registerEvents() {
				this.player.on(       'ended', this.onEnded.bind(this));
				this.player.on(       'error', this.onPlayerError.bind(this));
				this.player.on(      'loaded', this.onLoaded.bind(this));
				this.player.on(       'pause', this.onPaused.bind(this));
				this.player.on(        'play', this.onPlaying.bind(this));
				this.player.on(    'progress', this.onProgress.bind(this));
				this.player.on(  'timeupdate', this.onTimeUpdate.bind(this));
				this.player.on('volumechange', this.onVolumeChange.bind(this));
			}

			loadVideo() {
				if (this.parent.isLoading || this.parent.hasLoaded) return;

				this.parent.isLoading = true;
				this.elem.classList.add('is-loading');

				return this.player.loadVideo(this.id)
					   .then(() => {
					   		this.player.ready().then(() => {
					   			this.setDimensions(true);
					   			this.setDuration();

					   			this.inner.addEventListener('click', this.parent.togglePlayPause.bind(this.parent));

					   			window.removeEventListener('scroll', this.parent.checkVisibility.bind(this));
								window.removeEventListener('resize', this.parent.checkVisibility.bind(this));
					   		});
					   	})
					   .catch(err => console.error(err));
			}

			setDimensions(force = false) {
				if (force || this.width === null || this.height === null) {
					return this.getDimensions(true).then(((dimensions) => {
						this.width  = dimensions.width;
						this.height = dimensions.height;
						this.setDimensions();
						return { width: this.width, height: this.height };
					}).bind(this));
				}

				this.elem.style.aspectRatio = this.width + ' / ' + this.height;

				return { width: this.width, height: this.height };
			}

			getDimensions(force = false) {
				if (!force && this.width !== null && this.height !== null) {
					return new Promise(function(resolve, reject) {
						return dimensions;
					});
				}

				return Promise.all([this.player.getVideoWidth(), this.player.getVideoHeight()]).then((function(dimensions) {
					return { width: dimensions[0], height: dimensions[1] };
				}).bind(this));
			}

			setDuration() {
				this.player.getDuration().then((function(duration) {
					this.duration = duration;
				}).bind(this));
			}

			setHeight(newHeight) {
				this.inner.style.height = newHeight + 'px';
			}



			/************************************************
			 * Video event listeners
			 * **********************************************/

			onEnded(e) {
				this.parent.onEnded(e);
			}

			onLoaded(e) {
				this.inner.querySelector('iframe').setAttribute('playsinline', 'playsinline');
				this.player.getDuration().then((duration => {
					this.duration = duration;
					this.parent.onLoaded(e);
				}).bind(this))				
			}

			onPaused(e) {
				this.parent.onPaused(e);
			}

			onPlayerError(e) {
				this.parent.onPlayerError(e);
			}

			onPlaying(e) {
				this.parent.onPlaying();
			}

			onProgress(e) {
				this.parent.onProgress([{ start: 0, end: e.seconds }]);
			}

			onTimeUpdate(e) {
				this.currentTime = e.seconds;
				this.parent.onTimeUpdate(e);
			}

			onVolumeChange(e) {
				this.volume = e.volume;
				this.isMuted = e.volume == 0;
				this.parent.onVolumeChange(e);
			}



			/************************************************
			 * Fullscreen functions
			 * **********************************************/

			isFullscreenVideo = () => this.video.webkitDisplayingFullscreen;
			webkitEnterFullscreen = () => this.video.webkitEnterFullscreen;
			webkitExitFullScreen = () => this.video.webkitExitFullScreen;



			/************************************************
			 * 	Controls
			 * **********************************************/

			mute = () => this.player.setMuted(true);
			play = () => this.player.play();
			pause = () => this.player.pause();
			seekTo = (time) => this.player.setCurrentTime(time).then((() => this.currentTime = time).bind(this));
			setVolume = (volume) => this.player.setVolume(volume);
			stop = () => this.player.pause();
			unmute = () => this.player.setMuted(false);
		}



		/************************************************
		* 	YouTube Player
		* **********************************************/

		var youTubeInstances = [];

		var onYouTubeIframeAPIReady = function() {			
			youTubeInstances.forEach(instance => {
				instance.constructPlayer();
			});
		}

		class YouTubePlayer {
			constructor(elem, parent) {
				this.threshold  = 500;

				this.parent     = parent;
				this.elem       = elem;
				this.inner      = elem.querySelector('.video-inner');
				this.iframe     = this.inner.querySelector('iframe');
				this.video      = null;
				this.id         = this.inner.dataset.id;
				if (!this.id) return;

				this.hasInitialised = false;
				this.duration       = null;
				this.isAutoplay     = this.inner.dataset.autoplay == '1';
				this.isLooping      = this.inner.dataset.loop == '1';
				this.isMuted        = this.isAutoplay;
				this.startMuted     = this.isMuted;
				this.volume         = this.parent.baseVolume;

				this.width          = 1;
				this.height         = 1;
				this.timeUpdater    = null;
			}

			constructPlayer() {
				this.width = this.iframe.width;
				this.height = this.iframe.height;

				let width  = this.inner.clientWidth,
					ratio  = this.width / this.height,
					height = width / ratio;

				this.youtubeOptions = {
					videoId:        this.id,
					width:          width,
					height:         height,
					playerVars: {
						autoplay:       this.isAutoplay == '1' ? 1 : 0,
						controls:       0,
						disablekb:      0,
						enablejsapi:    1,
						fs:             0,
						iv_load_policy: 0,
						loop:           this.isLooping == '1' ? 1 : 0,
						modestbranding: 1,
						playsinline:    1,
						rel:            0,
						showinfo:       0,
					},
					events: {
						onError:       this.onPlayerError.bind(this),
						onReady:       this.onLoaded.bind(this),
						onStateChange: this.onStateChange.bind(this)
					}
				};

				this.hasInitialised = true;
				this.player = new YT.Player(this.iframe, this.youtubeOptions);
			}

			setDimensions(force = false) {
				this.inner.style.aspectRatio = this.width + ' / ' + this.height;
				return { width: this.width, height: this.height };
			}

			setDuration() {
				this.duration = this.player.getDuration();
			}



			/************************************************
			 * Video event listeners
			 * **********************************************/

			onStateChange(e) {
				if (e.data == 0) this.onEnded(e);
				if (e.data == 1) this.onPlaying(e);
				if (e.data == 2) this.onPaused(e);
				if (e.data == 3) this.onProgress(e);
				if (e.data == 5) this.onTimeUpdate(e);
			}

			onEnded(e) {
				clearInterval(this.timeUpdater);
				this.parent.onEnded(e);
			}

			onLoaded(e) {
				if (!this.hasInitialised || this.parent.isLoading || this.parent.hasLoaded) return;

				this.parent.isLoading = true;
				this.elem.classList.add('is-loading');

				this.setDimensions(true);
				this.setDuration();
				this.inner.addEventListener('click', this.parent.togglePlayPause.bind(this.parent));
				this.parent.onLoaded(e);
			}

			onPaused(e) {
				clearInterval(this.timeUpdater);
				this.parent.onPaused(e);
			}

			onPlayerError(e) {
				this.parent.onPlayerError(e);
			}

			onPlaying(e) {
				this.timeUpdater = setInterval(this.onTimeUpdate.bind(this), 100);
				this.parent.onPlaying();
			}

			onProgress() {
				this.parent.onProgress([{ start: 0, end: this.player.getVideoLoadedFraction() * this.duration }]);
			}

			onTimeUpdate() {
				this.currentTime = this.player.getCurrentTime();
				this.parent.onTimeUpdate();
			}



			/************************************************
			 * Fullscreen functions
			 * **********************************************/

			isFullscreenVideo = () => this.video.webkitDisplayingFullscreen;
			webkitEnterFullscreen = () => this.video.webkitEnterFullscreen;
			webkitExitFullScreen = () => this.video.webkitExitFullScreen;



			/************************************************
			 * 	Controls
			 * **********************************************/

			mute = () => {
				if (!this.hasInitialised) return;
				this.player.mute();
			}

			play = () => {
				if (!this.hasInitialised) return;
				this.player.playVideo();
			}

			pause = () =>  {
				if (!this.hasInitialised) return;
				this.player.pauseVideo();
			}

			seekTo = (time) => {
				if (!this.hasInitialised) return;
				this.player.seekTo(time);
			}

			setVolume = (volume) => {
				if (!this.hasInitialised) return;
				this.player.setVolume(volume * 100);
				this.volume = volume;
				this.isMuted = volume == 0;
				this.parent.onVolumeChange();
			}

			stop = () => {
				if (!this.hasInitialised) return;
				this.pause();
				this.seekTo(0);
			}

			unmute = () => {
				if (!this.hasInitialised) return;
				this.player.unMute();
			}
		}

		window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;
		elems.forEach(e => new VideoPlayer(e));
	}




	/***************************************
		Credits
	***************************************/

	var credits = function() {
		var credits = '\n\nThis website was designed by FRENDZ.CLUB.\nwww.frendz.club\n\nIt was built by Matthias Planitzer.\nwww.matthias-planitzer.de\n\n';
		console.log('%c' + credits, 'color: #00F; font-family: Helvetica Neue, Helvetica, sans-serif; font-size: 14px;');	
	}








	/***************************************
		Swipe detect
	***************************************/

	class SwipeDetect {
		constructor(elem, callback, args) {
			var defaults = {
				minDistance:       50,
				addMouseEvents:    true,
				addDragDropEvents: true,
				horizontal:        true,
				vertical:          true,
				stagger:           100,
				passive:           true
			};

			this.elem      = elem;
			this.callback  = callback;
			this.args      = Object.assign(defaults, args);

			this.active    = false;
			this.eventType = null;
			this.lastPos   = { x: null, y: null };
			this.lastEmit  = Date.now();
			
			this.registerEvents();
		}

		destruct() {
			this.elem.removeEventListener('touchstart', this.fn.startTouch);
			this.elem.removeEventListener('touchmove',  this.fn.move);
			this.elem.removeEventListener('touchend',   this.fn.end);

			if (this.args.addMouseEvents) {
				this.elem.removeEventListener('mousedown',  this.fn.startMouse);
				this.elem.removeEventListener('mousemove',  this.fn.move);
				this.elem.removeEventListener('mouseleave', this.fn.end);
				 document.removeEventListener('mouseup',    this.fn.end);
			}

			if (this.args.addDragDropEvents) {
				this.elem.removeEventListener('dragstart', this.fn.startDragDrop);
				this.elem.removeEventListener('dragleave', this.fn.end);
				this.elem.removeEventListener('dragexit',  this.fn.end);
				this.elem.removeEventListener('drop',      this.fn.end);
			}
		}

		registerEvents() {
			this.fn = {
				startDragDrop: this.startDragDrop.bind(this),
				startMouse:    this.startMouse.bind(this),
				startTouch:    this.startTouch.bind(this),
				move:          this.move.bind(this),
				end:           this.end.bind(this),
			};

			this.elem.addEventListener('touchstart', this.fn.startTouch, { passive: this.args.passive });
			this.elem.addEventListener('touchmove',  this.fn.move, { passive: this.args.passive });
			this.elem.addEventListener('touchend',   this.fn.end, { passive: this.args.passive });

			if (this.args.addMouseEvents) {
				this.elem.addEventListener('mousedown',  this.fn.startMouse, { passive: this.args.passive });
				this.elem.addEventListener('mousemove',  this.fn.move, { passive: this.args.passive });
				this.elem.addEventListener('mouseleave', this.fn.end, { passive: this.args.passive });
				 document.addEventListener('mouseup',    this.fn.end, { passive: this.args.passive });
			}

			if (this.args.addDragDropEvents) {
				this.elem.addEventListener('dragstart', this.fn.startDragDrop, { passive: this.args.passive });
				this.elem.addEventListener('dragleave', this.fn.end, { passive: this.args.passive });
				this.elem.addEventListener('dragexit',  this.fn.end, { passive: this.args.passive });
				this.elem.addEventListener('drop',      this.fn.end, { passive: this.args.passive });
			}
		}

		startTouch(event) {
			this.active    = true;
			this.eventType = 'touch';
			this.lastPos   = this.getPosition(event);
		}

		startMouse(event) {
			this.active    = true;
			this.eventType = 'mouse';
			this.lastPos   = this.getPosition(event);
		}

		startDragDrop(event) {
			this.active    = true;
			this.eventType = 'dragdrop';
			this.lastPos   = this.getPosition(event);
		}

		move(event) {
			if (!this.active) return;

			var now         = Date.now(),
				timeElapsed = now - this.lastEmit;
			if (timeElapsed < this.args.stagger) return;

			var	newPos      = this.getPosition(event),
				distance    = this.distance(this.lastPos, newPos),
				result      = {
					distance2D:  Math.sqrt(distance.x * distance.x + distance.y * distance.y),
					direction2D: Math.atan2(distance.y, distance.x),
					type:        this.eventType,
					event: 		 event
				};

			if (this.args.horizontal) {
				result.distanceX  = distance.x;
				result.directionX = Math.sign(distance.x / this.args.minDistance);
			}

			if (this.args.vertical) {
				result.distanceY  = distance.y;
				result.directionY = Math.sign(distance.y / this.args.minDistance);
			}
			
			if ((result.directionX !== 0 && this.args.horizontal) ||
				(result.directionY !== 0 && this.args.vertical)) {
				this.lastPos  = newPos;
				this.lastEmit = now;

				this.callback(result);
			}
		}

		end(event) {
			this.active = false;
		}

		getPosition(event) {
			var pos = this.eventType == 'touch' ? event.touches[0] : event;
			return { x: pos.clientX, y: pos.clientY };
		}

		distance(pos1, pos2) {
			return { x: pos1.x - pos2.x, y: pos1.y - pos2.y };
		}
	}




	init();
})();